export class TicketCloseCommand {
    ticketId: string;
    closedBy: string;
    closedByEmail: string;
    comments: string;

    constructor(params: {
    ticketId: string;
    closedBy: string;
    closedByEmail: string;
    comments: string;
  }) {
    this.ticketId = params.ticketId;
    this.closedBy = params.closedBy;
    this.closedByEmail = params.closedByEmail;
    this.comments = params.comments;
    }
}
